export default "__VITE_ASSET__CGCEo4tr__"